<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
  mounted() {
    window.entryUrl = window.location.href.split('#')[0]; // 微信签名
  },
}
</script>

<style>
@import url('@/assets/style/common.scss');
</style>
